import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const UserThinFilled = (props: IconProps) => {
    const { color = "#000", ...rest } = props
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g clipPath="url(#clip0_83_25067)">
                <path d="M7.66927 7.33252C7.27531 7.33252 6.8852 7.25492 6.52122 7.10416C6.15724 6.95339 5.82653 6.73242 5.54795 6.45384C5.26937 6.17526 5.0484 5.84455 4.89763 5.48057C4.74687 5.11659 4.66927 4.72649 4.66927 4.33252C4.66927 3.93855 4.74687 3.54845 4.89763 3.18447C5.0484 2.82049 5.26937 2.48977 5.54795 2.2112C5.82653 1.93262 6.15724 1.71165 6.52122 1.56088C6.8852 1.41012 7.27531 1.33252 7.66927 1.33252C8.46492 1.33252 9.22798 1.64859 9.79059 2.2112C10.3532 2.77381 10.6693 3.53687 10.6693 4.33252C10.6693 5.12817 10.3532 5.89123 9.79059 6.45384C9.22798 7.01645 8.46492 7.33252 7.66927 7.33252ZM7.66927 7.99919C8.10701 7.99919 8.54046 8.0854 8.94488 8.25292C9.3493 8.42044 9.71676 8.66597 10.0263 8.9755C10.3358 9.28503 10.5814 9.65249 10.7489 10.0569C10.9164 10.4613 11.0026 10.8948 11.0026 11.3325V13.9992H4.33594V11.3325C4.33594 10.4485 4.68713 9.60062 5.31225 8.9755C5.93737 8.35038 6.78522 7.99919 7.66927 7.99919Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_83_25067">
                    <rect width="16" height="16" fill={color} transform="translate(0 -0.000488281)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default UserThinFilled